<template>
  <div class="choose-staff-item">
    <Row type="flex" align="middle">
      <Col span="2">
        <template v-if="multiple">
          <Checkbox
            :label="node.id"
            v-model="node.checked"
            :key="node.id"
            @on-change="handleCheckChange"
          >
          </Checkbox>
        </template>
        <template v-else>
          <Radio
            :label="node.id"
            :key="node.id"
            :value="node.checked"
            @on-change="handleCheckChange"
            ><span></span
          ></Radio>
        </template>
      </Col>
      <Col span="20">
        <div class="choose-staff-item-title">{{ node.name }}</div>
        <div class="choose-staff-item-name u-ellipsis">
          {{ node[props.desc] }}
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "node",
  props: {
    node: {
      default() {
        return {};
      }
    },
    props: {
      default() {
        return {
          desc: "desc"
        };
      }
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      oldChecked: null
    };
  },
  methods: {
    handleCheckChange(status) {
      this.node.setChecked(status);
    },
    handleSelectChange(checked) {
      if (this.oldChecked !== checked) {
        this.$emit("on-change", this.node.data, checked);
      }
      this.oldChecked = checked;
    }
  },
  watch: {
    "node.checked"(val) {
      this.handleSelectChange(val);
    }
  }
};
</script>

<style scoped lang="less">
.choose-staff {
  &-item {
    border-bottom: 1px solid #e1e3e5;
    padding: 9px 0;
    &-title {
      font-size: 14px;
      color: #333;
    }
    &-name {
      font-size: 12px;
      color: #666;
    }
  }
}
</style>
